import moment from 'moment';
import { createReducer } from 'typesafe-actions';
import withJobs from '../../_core/job/reducers';
import {
    IORB1Store,
} from './@types';
import orb1Actions, { EORB1Constants, TORB1Actions } from './actions';

const defaultState: IORB1Store = {
    _jobs: {},
    currentOperation: undefined,
    records: {
        byIds: {},
        ids: [],
    },
    filter: {
        startDate: moment().subtract(7, 'days').toDate(),
        endDate: moment().add(1, 'day').toDate(),
        shownRecords: 'ALL',
		vesselId: '',
    },
};
const orb1Reducers = createReducer<IORB1Store, TORB1Actions>(defaultState)
    .handleAction(
        orb1Actions.document.historySet,
        function historySet(state, action) {
            return {
                ...state,
                records: action.payload.history,
            };
        }
    )
    .handleAction(
        orb1Actions.document.setFilter,
        function setFilter(state, action) {
            return {
                ...state,
                filter: action.payload.filter,
            };
        }
    );

export default withJobs<IORB1Store>(
    EORB1Constants.FEATURE,
    defaultState,
    orb1Reducers
);
